module.exports = __webpack_public_path__ + "static/media/codespot.776a3f04.PNG";